import { type PropertyDefinitions } from '../../types';
import cycleDefaultSvg from '../../assets/cycleDefault.svg';
import cycleCirclesSvg from '../../assets/cycleCircles.svg';
import cycleArrowBehindSvg from '../../assets/cycleArrowBehind.svg';

// DSL describing the available properties for a cycle diagram.
const properties: PropertyDefinitions = {
  variant: {
    name: 'Overall style of the cycle diagram',
    type: 'selectProperties',
    options: [
      {
        value: 'default',
        name: 'Simple cycle diagram',
        properties: { shape: 'roundRect' },
        icon: cycleDefaultSvg,
      },
      {
        value: 'circles',
        name: 'Cycle diagram with circles',
        properties: { shape: 'circle' },
        icon: cycleCirclesSvg,
      },
      {
        value: 'arrowBehind',
        name: 'Cycle diagram with single arrow',
        properties: { shape: 'roundRect', arrowLocation: 'behind' },
        icon: cycleArrowBehindSvg,
      },
    ],
  },
  arrowLocation: {
    name: 'Where to draw arrows',
    type: 'select',
    options: [
      { value: 'between', name: 'Arrows connect each shape' },
      { value: 'behind', name: 'A single arrow behind the whole cycle' },
      { value: 'none', name: "Don't display any arrows" },
    ],
  },
  arrowStyle: {
    name: 'The head and tail style of the arrows',
    type: 'select',
    options: [
      { value: 'hat', name: 'Pointing arrow' },
      { value: 'inlineHead', name: 'Arrow with an inline head' },
      { value: 'inlineBoth', name: 'Arrow with inline head and tail' },
    ],
  },
  arrowThickness: {
    name: 'The width of the arrow lines',
    type: 'number',
    default: 20,
    rangeFrom: 1,
    rangeTo: 100,
  },
};

export default properties;
